export default __webpack_public_path__ + "static/media/my-bg-5.6e976c82.png";